export const newTagToken = {
  textFontSizeB300: '10px',
  textLineHeightB300: '14px',
  textFontWeightB300: '500',
  textColorPrimary: '#BF8E00',
  boxBorderWidth: '0px',
};

export const toolTipToken = {
  popoverBackgroundColorFill: 'white',
  popoverForegroundColorFill: '#697576',
};
